// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","925":"component---src-pages-faq-tsx"}[chunkId] || chunkId) + "-" + {"245":"f8a9a787a26290310f3d","453":"20619882621c2d741039","522":"6ca03fa1f3a5e3735a95","925":"228db29a18304d6154f3"}[chunkId] + ".js";
};